export class Login {
  static readonly type = '[Auth] Login';
  constructor(public payload: { username: string; password: string }) {}
}

export class HelloLogin {
  static readonly type = '[Auth] HelloLogin';
  constructor(public payload: { refreshToken: string }) {}
}


export class Logout {
  static readonly type = '[Auth] Logout';
  constructor(public payload: string) {}
}

export class Reset {
  static readonly type = '[Auth] Reset';
}

export class UpdateTokens {
  static readonly type = '[Auth] UpdateTokens';
  constructor(
    public payload: {
      accessToken?: string;
      refreshToken?: string;
      firstName?: string;
      lastName?: string;
    }
  ) {}
}

/**
 *
 * import { User } from '@app/modules/core/models/user';


export class AddUser {
    static readonly type = '[User] Add';
    constructor(public payload: User) {}
}

 *
 */
